var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{ref:"googleButton"})])}
var staticRenderFns = []

export { render, staticRenderFns }